// 「最後に選んだ研究室」をユーザーごとに localStorage へ保存する。
// ・ユーザー単位のキーにして、共用PCで別ユーザーの選択が混ざらないようにする。
// ・読み出し側は必ず所属研究室(userLabs)で妥当性を検証してから使うこと。
const key = (userId: number) => `lastSelectedLab:${userId}`;

export function saveLastLab(userId: number, labId: number): void {
  try {
    localStorage.setItem(key(userId), String(labId));
  } catch {
    // localStorage 不可の環境では単に保存しない
  }
}

export function getLastLab(userId: number): number | null {
  try {
    const raw = localStorage.getItem(key(userId));
    const n = raw ? Number(raw) : NaN;
    return Number.isNaN(n) ? null : n;
  } catch {
    return null;
  }
}
